import { routes } from 'utils/routes';
import { cta } from 'utils/cta';

export const footerLinks = [
  {
    title: 'Learn',
    links: [
      { label: 'How it works', ...routes.howItWorks },
      { label: 'Pricing', ...routes.pricing },
      { label: 'Compare options', ...routes.compare },
      { label: 'Blog', ...routes.blog },
      { label: 'Join the team', ...routes.joinTeam },
    ],
  },
  {
    title: 'Support',
    links: [
      { label: 'FAQ', ...routes.faq },
      { label: 'Shipping Info', ...routes.shipping },
      { label: 'Contact us', ...routes.contacts },
      { label: cta.getStarted, ...routes.getStarted },
      { label: 'User login', ...routes.login },
    ],
  },
  {
    title: 'Trust',
    links: [
      { label: 'Results', ...routes.results },
      { label: 'Guarantees', ...routes.guarantees },
      { label: 'About', ...routes.about },
      { label: 'Press kit', ...routes.press },
      { label: 'Health solutions: Instant Dentist', ...routes.partners },
    ],
  },
];
